import React, { Component } from 'react';

/**
 * AgentStatusPanel — pure UI spinner / done indicator
 *
 * Props:
 *  - agentDone : boolean
 */
export default class AgentStatusPanel extends Component {
  render() {
    const { agentDone } = this.props;

    if (agentDone) {
      return (
        <div className="agent-panel agent-panel--done" aria-live="polite">
          <div className="agent-text">Agent working</div>
        </div>
      );
    }

    return (
      <div className="agent-panel" aria-live="polite">
        <div className="agent-row">
          <div className="agent-spinner" aria-hidden="true" />
          <div className="agent-text">Storyclub agent is running</div>
        </div>
      </div>
    );
  }
}
